export class W3OnPageNavigation {
  onPageNavigation: HTMLElement | null;
  headerHeight: number;
  initialPositionSet: boolean = false;
  initialBottomPosition: string;
  header: HTMLElement | null;
  links: NodeListOf<HTMLAnchorElement> | null;
  sections: HTMLElement[] | null;
  scrollGhost: HTMLElement | null;

  constructor() {
    this.onPageNavigation = document.querySelector(".on-page-navigation");
    this.headerHeight = document.querySelector("#header")?.clientHeight || 0;
    this.header = document.querySelector("#header");
    this.initialBottomPosition = "0"; // Assume starting at bottom '0px'
    this.links = document.querySelectorAll(".on-page-navigation__link");
    this.scrollGhost = document.querySelector(".on-page-navigation--ghost");
    if (this.links.length > 0) {
      this.sections = Array.from(this.links).map(
        (link) =>
          document.querySelector(link.getAttribute("href")) as HTMLElement,
      );
    }

    if (this.onPageNavigation) {
      this.registerScrollListener();
      this.observeSections();
    } else {
      return;
    }
  }

  /**
   * Register the scroll listener and trigger scroll logic
   */
  private registerScrollListener(): void {
    if (window.innerWidth > 1024) {
      const scrollMenu = this.onPageNavigation;
      const scrollGhost = this.scrollGhost;
      if (scrollMenu) {
        const header = this.header;
        const scrollOffset = this.getOffset(scrollMenu);
        let stickyOffset = scrollOffset - header.clientHeight; // Abstand vom oberen Ende des Viewports
        let lastScrollTop: number = 0;

        //check if page already is scrolled down
        if (window.scrollY > stickyOffset) {
          scrollMenu.classList.add("sticky");
          scrollGhost.style.position = "relative";
        }

        window.addEventListener("scroll", function () {
          stickyOffset = scrollOffset - header.clientHeight;
          const scrollTop = window.scrollY;
          if (scrollTop >= stickyOffset && scrollTop <= stickyOffset + 100) {
            scrollMenu.classList.add("sticky");
            scrollGhost.style.position = "relative";
          } else if (scrollTop >= stickyOffset + 100) {
            if (scrollTop > lastScrollTop) {
              header?.style.transform = "translateY(-100%)";
              scrollMenu.style.transform = "translateY(-100%)";
            } else {
              header?.style.transform = "translateY(0%)";
              scrollMenu.style.transform = "translateY(0%)";
            }
          } else {
            header?.style.transform = "translateY(0%)";
            header?.style.transition = "all .1s $cubic-baizer";
            scrollMenu.classList.remove("sticky");
            scrollGhost.style.position = "absolute";
            scrollMenu.style.transform = "translateY(0%)";
          }
          lastScrollTop = scrollTop;
        });
      }
    }
  }

  /**
   * Get the offset of an element from the top of the page
   */
  private getOffset(element: HTMLElement | null): number {
    if (!element) return;
    const rect = element.getBoundingClientRect();
    return rect.top + window.scrollY;
  }

  /**
   * Observe sections and highlight the corresponding link in the on-page-navigation
   */
  private observeSections(): void {
    let anySectionActive = false;
    const observer = new IntersectionObserver(
      (entries) => {
        anySectionActive = false;

        entries.forEach((entry) => {
          const index = this.sections.indexOf(entry.target as HTMLElement);

          if (index !== -1) {
            if (entry.isIntersecting) {
              anySectionActive = true;
              this.activateLink(this.links[index]);
            }
          }
        });
        // If after checking all entries no section is active, remove active class from all links
        if (!anySectionActive) {
          this.deactivateAllLinks();
        }
      },
      { threshold: 0.5 },
    );

    this.sections.forEach((section) => {
      if (section) observer.observe(section);
    });
  }

  /**
   * Activate a link in the on-page-navigation
   * @param link   The link to activate
   */
  private activateLink(link: HTMLElement) {
    this.links.forEach((lnk) => lnk.classList.remove("active"));
    link.classList.add("active");
  }

  /**
   * Deactivate all links in the on-page-navigation
   */
  private deactivateAllLinks() {
    this.links.forEach((link) => link.classList.remove("active"));
  }
}
